import axios from "axios";
import { getApiUrl } from "../config/credentials";

/**
 * Se define objeto de conexión
 */
export const API = axios.create({
  baseURL: getApiUrl()
});
